// extracted by mini-css-extract-plugin
module.exports = {"footer-info":"_2skxSV1qKdJVNTVquRqcf7","body":"_2Q2r-p47GZUrqNQq1tNyHs","dialog":"mKi9lSHBsiF_WK79MaMft","table":"_1UH8HI8lHrOSvh8QRkyqUv"};